module.exports = __webpack_public_path__ + "static/media/img-axum-quote@3x.0a0f6b7c.png";